import { number } from 'echarts/core';


export enum EnumStatusTabS {
    allTab='0',
    noCompleted='1',
    completed = '2',
    canceled = '3',
    waitingFeedback = '4',
}
export enum EnumStudentTypes{
    memberName = '学员姓名',
    memberId = '教务ID',
    onlineMemberId = '网校ID',
    mobile = '手机号',
}
export interface IStudentInfoTypesItem{
    type:EnumStudentTypes,
    key:number
}
export enum EnumOperates{
    stuentArchives = '学员档案',
    stuentStudySituation = '学员学请',
    operateRecodLog = '操作记录',
    editCourse = '编辑课程'
}
export enum EnumServiceTypes{
    phone = 100529221 ,
    live = 100529222,
    face = 100529223,
}
//预约状态 0 已预约未开始 1上课中 2已下课 3已取消 4待反馈 5已反馈
export enum EnumFilterTaskStatus{
     unStart = 0,
     inClass = 1,
     completed = 2,
     canceled = 3,
     waitingFeedback = 4,
     hasFeedback = 5,
}
export enum EnumCommentsStatus{
    undo = 0,
    done = 1,
}
//排序相关
export enum EnumSortTypes{
    apiDesc = 'desc',
    apiAsc = 'asc',
    tableAscend = 'ascend',
    tableDescend = 'descend',
}
//排序的key
export enum EnumSortkeys{
    startTime = 'start_time',//任务开始时间（任务时间段）
    createTime = 'create_time',//创建时间（任务提交时间）
    completeTime = 'complete_time'//处理完成时间（处理完成时间）
}

// 2000330        20016        座机
// 2000331        20016        QQ/微信
// 2000332        20016        其他
// 2000333        20016        报备
// 2000334        20016        手机
// 2000335        20016        微信语音
// 2000336        20016        短信
// 2000337        20016        面访
// 2000338        20016        智能电话
export enum EnumReportTypes {
    specialPlane = 2000330,
    qqOrWx = 2000331,
    other = 2000332,
    report = 2000333,
    phone = 2000334,
    wxAudio = 2000335,
    message = 2000336,
    face = 2000337,
    snartPhone = 2000338,
    live = 100529924,
    enterpriseWeChat = 100530257
}
export type TOperateItem = {
    name:EnumOperates,
    key:number
}

export interface IStatusTabItem {
    key:EnumStatusTabS,
    name:string,
    num?:number
}
export interface IReqGetOrganizationTreeParams{
    roleId:string|number,
    userId:string|number
}
export interface IResultGetOrganizationTreeNode{
    userId:number|string,
    userName?:string,
    trueName:string,
    email?:string,
    departmentName?:string,
    departmentId?:string|number,
    children:IResultGetOrganizationTreeNode[]
}
export interface IReqProcessListParams{
    startTime?:string,//任务开始时间
    endTime?:string,//任务结束时间
    completeStartTime?:string,//处理完成开始时间
    completeEndTime?:string,//处理完成结束时间
    projectId?:string|number,//项目id
    serviceTeamId?:string|number,//团队id
    subjectId?:string|number,
    userIds?:number|string[],
    memberName?:string,//学员姓名
    memberId?:number|string,//学员教务id
    onlineMemberId?:number|string,//学员网校id
    mobile?:number|string,//手机号
    pageSize?:number,//一页多少条
    pageNum?:number,//页码
    sortField?:string,//排序字段：任务开始时间：p.start_time 处理完成时间：p.complete_time
    sortValue?:string,//desc-降序；asc-升序
    serviceType?:number[],//服务类型 100529222 直播 100529221 电话 100529223面授
    commentsStartTime?:string,//学生评价时间（开始时间
    commentsEndTime?:string,//学生评价时间（结束时间）
    lessonStatus?:string,//lesson0 未开始 1 上课中
    realServiceStartTime?:string|number,//实际服务时间（开始时间）
    realServiceEndTime?:string|number,//实际服务时间（结束时间）
    processStatus?:number[],//查询列表类型 0 所有 1 待上课 2已结束 3 已取消 4 待反馈
    commentsStatus?:number[],
    twoSubjectId?:number|string
}

export interface IProcessListItem{
     id:number,                //类型：Number  必有字段  备注：私教预约id
    memberId:number|string,                //类型：Mixed  必有字段  备注：学员id
    memberName:string,                //类型：String  必有字段  备注：学员姓名
    onlineMemberId:string|number,                //类型：String  必有字段  备注：学员姓名
    serviceType:number,                //类型：Number  必有字段  备注：上课方式id
    serviceTypeName:string,                //类型：String  必有字段  备注：上课方式名称
    description:string,                //类型：String  必有字段  备注：问题描述
    memberImage:string,                //类型：String  必有字段  备注：图片
    serviceDate:string,                //类型：String  必有字段  备注：私教日期(2021-11-02)
    serviceTime:string,                //类型：String  必有字段  备注：私教服务时间段18:00-20:00
    teacherId:number,                //类型：Number  必有字段  备注：学术老师id
    teacherName:string,                //类型：String  必有字段  备注：学术老师名称
    processStatus:number,                //类型：Number  必有字段  备注：预约状态 0 未开始 1上课中 2已下课 3已取消 4待反馈 5已反馈
    isLike:number,                //类型：Number  必有字段  备注：评价结果：1、非常满意 2、不满意 3、满意
    resolveResult:number,                //类型：Mixed  必有字段  备注：问题解决：1、没解决，2、解决了，3、超过预期
    teachAttitude:number,                //类型：Number  必有字段  备注：私教态度：1、非常满意 2、不满意 3、满意
    studentComment:string,                //类型：Mixed  必有字段  备注：评价内容
    commentsTime:string,                //类型：Mixed  必有字段  备注：评价时间
    projectId:number,                //类型：Number  必有字段  备注：项目id
    projectName:string,                //类型：String  必有字段  备注：项目名称
    serviceTeamId:number,                //类型：Number  必有字段  备注：团队id
    serviceTeamName:string,                //类型：String  必有字段  备注：团队名称
    subjectId:number,                //类型：Number  必有字段  备注：科目id
    subjectName:string,                //类型：String  必有字段  备注：科目名称
    twoSubjectId:number,                //类型：Number  必有字段  备注：二级科目id
    twoSubjectName:string,                //类型：String  必有字段  备注：二级科目名称
    bookingNum:string,                //类型：Mixed  必有字段  备注：预约周期
    createTime:string,                //类型：String  必有字段  备注：预约提交时间
    completeTime:string,                //类型：Mixed  必有字段  备注：处理完成时间
    completeType:number,                //类型：Number  必有字段  备注：跟进方式
    completeTypeName:string,                //类型：String  必有字段  备注：根据方式名称
    remark:string,                //类型：Mixed  必有字段  备注：备注
    realServiceTime:number,                //类型：Mixed  必有字段  备注：实际服务时长
    totalServiceTime:number,
    sourcesType:number,                //类型：Number  必有字段  备注：来源 0-默认教研 1- 测评
    evaluationReportId:number,
    sourcesRemark:string,                //类型：Mixed  必有字段  备注：测评备注
    supportReport:number,                //类型：Mixed  必有字段  备注：是否有反馈报告
    submitSupportReport:number,
    contentValue:string,                //类型：Mixed  必有字段  备注：内容价值
    teachingAttitude:string,                //类型：Mixed  必有字段  备注：教学态度
    networkQuality:string,                //类型：Mixed  必有字段  备注：网络质量
    evaluationSource:number               //类型：Number  必有字段  备注：评价来源 0-默认教研 1-测评
    commentsStatus:number,
    processId:number,
    isSubmitFeedbackReportId:boolean,                //类型：String  必有字段  备注：是否已提交反馈报告 true 已提交 false 未提交
    processFeedbackReportId:number,                //类型：String  必有字段  备注：反馈报告id
    isSupportReport:number,                //类型：String  必有字段  备注：1
    processFeedbackReportIsCommit: number //"反馈报告是否提交：-1默认未提交 0暂存 1提交"  
    replyContent: string   //回复内容
    replyStatus: number //类型：Number 必有字段 备注：0评价老师未回复 1评价老师己回复
    showCommentPopover: boolean,
    evaluationReply: number,    
    guid: number,
}  

export interface IResultGetProcessList{
    pageNum:number,                //类型：Number  必有字段  备注：无
    pageSize:number,                //类型：Number  必有字段  备注：无
    size:number,                //类型：Number  必有字段  备注：无
    startRow:number,                //类型：Number  必有字段  备注：无
    endRow:number,                //类型：Number  必有字段  备注：无
    pages:number,                //类型：Number  必有字段  备注：无
    prePage:number,                //类型：Number  必有字段  备注：无
    nextPage:number,                //类型：Number  必有字段  备注：无
    isFirstPage:boolean,                //类型：Boolean  必有字段  备注：无
    isLastPage:boolean,                //类型：Boolean  必有字段  备注：无
    hasPreviousPage:boolean,                //类型：Boolean  必有字段  备注：无
    hasNextPage:boolean,                //类型：Boolean  必有字段  备注：无
    navigatePages:number,                //类型：Number  必有字段  备注：无
    navigatepageNums: any,
    navigateFirstPage:number,                //类型：Number  必有字段  备注：无
    navigateLastPage:number,
    total:number,     
    list:IProcessListItem[]
}

export interface IReqReportVisitParams{
    processIds:number[],//预约id
    studentManagerId:number|string,//学管id
    reportType:number,//学管id 报备类型沟通方式（2000330：OB ， 2000331：QQ/微信 ， 2000332：其他 , 2000333：报备）
    remark:string,//描述
    isGenerate?:number,//是否生成回放是否生成回访1 是 0 否
    serviceStartTime:string,//开始服务时间（格式yyyy-mm-dd HH:mm:ss）
    serviceEndTime:string,//开始服务时间（格式yyyy-mm-dd HH:mm:ss）
    certFiles?: string[]; // 附件图片
}
export interface IReqchangeCrocessTeacherIdParams{
    userId:number|string,//需要转移到的老师id
    processIdList:string|number[]//预约id
}

export interface IReqliveLessonServiceTimeParams{
    processId:number|string,
    startTime:number,
    endTime:number,
    serviceTime:number
}

export interface IResHistoryquestion{
    description:string,                //类型：String  必有字段  备注：问题
    createdAt:string,                //类型：String  必有字段  备注：修改时间
    sourceType:number,                //类型：Number  必有字段  备注：是否从其他系统过来的预约,0-当前系统 1-测评
    memberImage:string              //类型：String  必有字段  备注：图片
}

export interface IReplyContent { 
    businessId: number, 
    createdAt: string,
    editNum: number,
    replyContent: string
    teacherName: string
    updatedAt: string
}

export interface IResultRecordLogItem{
    studentName:string,
    recordId:number,
    operater:string,
    operateContent:string,
    operateTime:string
}

export interface IResAudioListItem{
    beginTime:string,
    callCenterType:number,
    callFileUrl:string,
    callStatus:number,
    duration:number,
    endTime:string,
    externalRecordId:string
}

export interface ITransferTeacherListItem{
    userId:number,
    name:string,
    studentNum:number,
}

export interface IResrelevanceCourseListItem{
    processId:number,
    bookingId:number,
    memberId:number,
    memberName:string,
    reserveMobile:string,
    startTime:string,
    endTime:string,
    key:number
}

export interface IReadlyQuestion {
	appraise: string;
	question: string;
	questionId: number;
	score: number;
	studentEvaluationClickOptionList?:{
		clickOptionId: number
		option: string
		remark: string
	}[];
}